import React, { useState, useEffect } from 'react'
import { Pill } from './DateRangePicker.style'
import { FaChevronDown, FaTimes } from 'react-icons/fa'
import classnames from 'classnames'

const Picker = ({ active, onOpen, onClose, label }) => {
  //Prevent blinking effect
  const [isActive, setIsActive] = useState(false)
  useEffect(() => {
    setTimeout(() => {
      setIsActive(active)
    }, 500)
  }, [active])

  const handleOnClose = (e) => {
    e.stopPropagation()
    onClose()
  }

  return (
    <Pill
      className={classnames('pl-2', { active })}
      active={active ? 1 : 0}
      onClick={onOpen}
    >
      <span>{label}</span>
      {isActive ? <FaTimes onClick={handleOnClose} /> : <FaChevronDown />}
    </Pill>
  )
}

export default React.memo(Picker)
